import { section } from "@/neon";

import scrollIntoView from "@/lib/scrollIntoView";
import { backgroundVideoHandler } from "@/lib/a11y";

const selectors = {
  image: ".image",
  textBlock: ".image-with-text__text-block",
  video: ".image-with-text__video",
};

section("image-with-text", {
  animationObserver: null,
  videoHandler: null,

  onLoad() {
    this.textBlock = this.container.querySelector(selectors.textBlock);
    this.image = this.container.querySelector(selectors.image);
    const videoWrapper = this.container.querySelector(selectors.video);

    this.scrollAnimation = scrollIntoView(this.container);

    if (videoWrapper) {
      this.videoHandler = backgroundVideoHandler(this.container);
    }
  },

  onUnload() {
    this.videoHandler && this.videoHandler();

    this.scrollAnimation.unload();
  },
});
